// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"PositionSelector_checkboxContainer__2ga0y","playerPositionSelectors":"PositionSelector_playerPositionSelectors__2W-lc"};